const API_URL = process.env.REACT_APP_API_URL;

let apiUrls = {
    elements: `${API_URL}/wafer-seal-elements`,
    saveDiscountTable: `${API_URL}/wafer-seal-element/save-discount-table`
};

export default apiUrls;
